import { GetSecretValueCommand, SecretsManagerClient } from '@aws-sdk/client-secrets-manager';
import { raise, validateNotEmptyString } from '@weft/utils';
import type { ZodSchema } from 'zod';

const secretsManagerClient = new SecretsManagerClient();

export async function getRawRequiredSecret(secretId: string): Promise<string> {
  return getRequiredSecret<string>(secretId, false);
}

export async function getJsonRequiredSecret<SecretResponseType>(secretId: string, validator?: ZodSchema): Promise<SecretResponseType> {
  return getRequiredSecret<SecretResponseType>(secretId, true, validator);
}

async function getRequiredSecret<SecretResponseType>(secretId: string, getParsed: boolean, validator?: ZodSchema): Promise<SecretResponseType> {
  try {
    const { SecretString: unparsedSecret } = await secretsManagerClient.send(
      new GetSecretValueCommand({
        SecretId: secretId,
      }),
    ); 

    validateNotEmptyString(unparsedSecret);

    console.info(`Successfully fetched secret ${secretId}`);

    const secret = getParsed ? JSON.parse(unparsedSecret) : unparsedSecret;

    return validator ? validator.parse(secret) : secret;
  } catch (error) {
    return raise(`Error while getting secret ${secretId}: ${error}`);
  }
}